import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import utils from "byzantine/src/utils";
import { PromoFluentIds } from "byzantine/src/l10n/SettingFluentIds";
import SectionCard from "../../SectionCard";
import type { PromotionCardProps } from "./types";

const PromotionCard = ({ promotion }: PromotionCardProps) => {
  const { l10n } = useLocalization();
  const promoIndex = promotion.promo_index || 0;

  const fluentIds = new PromoFluentIds(promoIndex);
  const translatedPromotion = {
    title: l10n.getString(fluentIds.getTitle(), null, promotion.title),
    description: l10n.getString(
      fluentIds.getDescription(),
      null,
      promotion.description
    ),
    action_text: l10n.getString(
      fluentIds.getActionText(),
      null,
      promotion.action_text || "Learn more"
    )
  };

  return (
    <SectionCard classNames="dashboard-section-card padding--bottom--l">
      <div className="dashboard-section-container">
        <div className="dashboard-item-border-box" data-testid="promotion-item">
          <div className="dashboard-item promotion-item">
            <div className="dashboard-item-subsection promotion-icon-section">
              <span className={utils.ndsIconPrepend(promotion.icon)}></span>
            </div>
            <div className="dashboard-item-subsection dashboard-item-title-section">
              {translatedPromotion.title}
            </div>
          </div>
          <div className="dashboard-item-description">
            {translatedPromotion.description}
          </div>
          <div className="margin--top--s">
            <Button
              as="a"
              href={promotion.url}
              kind="plain"
              label={translatedPromotion.action_text}
              testId="promotion-action"
              rel="noreferrer"
              target="_blank"
            />
          </div>
        </div>
      </div>
    </SectionCard>
  );
};

export default PromotionCard;
